import * as React from 'react';

interface MailState {
    isHovered: boolean;
}

export default class Mail extends React.Component<unknown, MailState> {
	public state: MailState = {
		isHovered: false,
	};

	public render() {
		return (
			<div
				className="fixed bottom-4 right-4 z-30 self-end"
				style={{ marginBottom: this.state.isHovered ? '-3px' : '' }}>
				<a
					href="mailto:help@shippingrateslogic.com"
					title="Contact us"
					target="_blank"
					rel="noreferrer"
					onMouseOver={() => this.setState({ isHovered: true })}
					onMouseLeave={() => this.setState({ isHovered: false })}>
					<svg
						className="h-10 w-10"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg">
						{ this.state.isHovered
							? <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
							: <path d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76" />
						}
					</svg>
				</a>
			</div>
		);
	}
}
